(function () {
    'use strict';

    angular
        .module('app.editCustomReport', [])
        .controller('editCustomReportCtrl', ['$scope', '$rootScope', '$modal', '$modalInstance', 'editCustomReportService',
            function ($scope, $rootScope, $modal, $modalInstance, editCustomReportService) {

                $scope.confirmEdit = function() {
                    var params = {
                        id: $scope.reportId,
                        company_id: $scope.selectedAdvertiser,
                        report_name: $scope.customReportName,
                        sections: $scope.selectedSection
                    }

                    editCustomReportService.editCustomReport(params, true)
                        .then(function(response) {
                            $scope.editCustomReportModalInstance.close();
                            $scope.detailCustomReportModalInstance.close();
                            $scope.sendHttpRequest();
                        }, function(response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.closeModal = function() {
                    $modalInstance.close();
                }
            }
        ]);
})();